import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ BaseUrl }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };
  const [data, setdata] = useState("");
  // // load user information
  // // check if is Authorized or not , check is Authtenticated or not
  // // while loadin =>show a loadin
  // //  if user is Authenticated and isAuthorized =>render app =childern
  useEffect(() => {
    axios
      .get(`${BaseUrl}/user/userCurent`, { headers: headers })
      .then((res) => {
        setdata(res.data.user);
      })
      .catch((err) => {});
  }, []);
  const auth = localStorage.getItem("TOKEN");
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
